
const { createSlice } = require("@reduxjs/toolkit");
let initialState = {
    category: "",
    projectName: ""
}

const projectDetailsSlice = createSlice({
    name: "projectDetails",
    initialState,
    reducers: {
        setProjectCategoryAndName: (state, action) => {
            state.category = action.payload.category;
            state.projectName = action.payload.projectName
        }
    }
})

export const { setProjectCategoryAndName } = projectDetailsSlice.actions;
export default projectDetailsSlice.reducer;